









import { onMounted, computed, defineComponent, ref } from '@nuxtjs/composition-api'

export default defineComponent({
  name: 'ToolTip',
  props: {
    borderColor: {
      type: String,
      default: 'rgb(102 153 204)',
    },
    textColor: {
      type: String,
      default: 'black',
    },
    bgColor: {
      type: String,
      default: 'white',
    },
    width: {
      type: String,
      default: '200px',
    },
    position: {
      type: String,
      default: 'center',
    },
  },

  setup(props) {
    const width = ref(props.width)
    const toolTipTextRef = ref()
    const positionClass = computed(() => {
      if (props.position === 'center') {
        return ''
      }
      return `tooltiptext-${props.position}`
    })

    onMounted(() => {
      width.value = toolTipTextRef.value.offsetWidth + 'px'
    })

    const toolTipStyle = computed<Record<string, any>>(() => ({
      '--width': width.value,
      '--border-color': props.borderColor,
      '--text-color': props.textColor,
      '--bg-color': props.bgColor,
    }))

    return { toolTipStyle, toolTipTextRef, positionClass }
  },
})
